import { render, staticRenderFns } from "./register-tips.vue?vue&type=template&id=8924f710&scoped=true"
import script from "./register-tips.vue?vue&type=script&lang=js"
export * from "./register-tips.vue?vue&type=script&lang=js"
import style0 from "./register-tips.vue?vue&type=style&index=0&id=8924f710&prod&lang=scss&scoped=true"
import style1 from "./register-tips.vue?vue&type=style&index=1&id=8924f710&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8924f710",
  null
  
)

export default component.exports